var _style, _rect, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _line24, _line25, _line26, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _line34, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _line57, _line58, _line59, _line60, _line61, _line62, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNounChat1133651(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    xmlns: "http://www.w3.org/2000/svg",
    x: "0px",
    y: "0px",
    viewBox: "0 0 512 512",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.noun_chat_1133651_st1{display:inline;fill:none;stroke:#000000;stroke-width:0.1;stroke-miterlimit:10;}\n\t.noun_chat_1133651_st2{stroke:#000000;stroke-miterlimit:10;}\n\t")), /*#__PURE__*/React.createElement("g", {
    style: {
      display: "none"
    }
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -196,
    y: 564,
    className: "noun_chat_1133651_st1",
    width: 512,
    height: 512
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 1060,
    x2: 316,
    y2: 1060
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 1044,
    x2: 316,
    y2: 1044
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 1028,
    x2: 316,
    y2: 1028
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 1012,
    x2: 316,
    y2: 1012
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 996,
    x2: 316,
    y2: 996
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 980,
    x2: 316,
    y2: 980
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 964,
    x2: 316,
    y2: 964
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 948,
    x2: 316,
    y2: 948
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 932,
    x2: 316,
    y2: 932
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 916,
    x2: 316,
    y2: 916
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 900,
    x2: 316,
    y2: 900
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 884,
    x2: 316,
    y2: 884
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 868,
    x2: 316,
    y2: 868
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 852,
    x2: 316,
    y2: 852
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 836,
    x2: 316,
    y2: 836
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 820,
    x2: 316,
    y2: 820
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 804,
    x2: 316,
    y2: 804
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 788,
    x2: 316,
    y2: 788
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 772,
    x2: 316,
    y2: 772
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 756,
    x2: 316,
    y2: 756
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 740,
    x2: 316,
    y2: 740
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 724,
    x2: 316,
    y2: 724
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 708,
    x2: 316,
    y2: 708
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 692,
    x2: 316,
    y2: 692
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 676,
    x2: 316,
    y2: 676
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 660,
    x2: 316,
    y2: 660
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 644,
    x2: 316,
    y2: 644
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 628,
    x2: 316,
    y2: 628
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 612,
    x2: 316,
    y2: 612
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 596,
    x2: 316,
    y2: 596
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -196,
    y1: 580,
    x2: 316,
    y2: 580
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 300,
    y1: 564,
    x2: 300,
    y2: 1076
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 284,
    y1: 564,
    x2: 284,
    y2: 1076
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 268,
    y1: 564,
    x2: 268,
    y2: 1076
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 252,
    y1: 564,
    x2: 252,
    y2: 1076
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 236,
    y1: 564,
    x2: 236,
    y2: 1076
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 220,
    y1: 564,
    x2: 220,
    y2: 1076
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 204,
    y1: 564,
    x2: 204,
    y2: 1076
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 188,
    y1: 564,
    x2: 188,
    y2: 1076
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 172,
    y1: 564,
    x2: 172,
    y2: 1076
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 156,
    y1: 564,
    x2: 156,
    y2: 1076
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 140,
    y1: 564,
    x2: 140,
    y2: 1076
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 124,
    y1: 564,
    x2: 124,
    y2: 1076
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 108,
    y1: 564,
    x2: 108,
    y2: 1076
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 92,
    y1: 564,
    x2: 92,
    y2: 1076
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 76,
    y1: 564,
    x2: 76,
    y2: 1076
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 60,
    y1: 564,
    x2: 60,
    y2: 1076
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 44,
    y1: 564,
    x2: 44,
    y2: 1076
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 28,
    y1: 564,
    x2: 28,
    y2: 1076
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: 12,
    y1: 564,
    x2: 12,
    y2: 1076
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -4,
    y1: 564,
    x2: -4,
    y2: 1076
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -20,
    y1: 564,
    x2: -20,
    y2: 1076
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -36,
    y1: 564,
    x2: -36,
    y2: 1076
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -52,
    y1: 564,
    x2: -52,
    y2: 1076
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -68,
    y1: 564,
    x2: -68,
    y2: 1076
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -84,
    y1: 564,
    x2: -84,
    y2: 1076
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -100,
    y1: 564,
    x2: -100,
    y2: 1076
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -116,
    y1: 564,
    x2: -116,
    y2: 1076
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -132,
    y1: 564,
    x2: -132,
    y2: 1076
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -148,
    y1: 564,
    x2: -148,
    y2: 1076
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -164,
    y1: 564,
    x2: -164,
    y2: 1076
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    className: "noun_chat_1133651_st1",
    x1: -180,
    y1: 564,
    x2: -180,
    y2: 1076
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "noun_chat_1133651_st2",
    d: "M219.3,241.9c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1s14.1-6.2,14.1-14.1   C233.4,248.2,227,241.9,219.3,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "noun_chat_1133651_st2",
    d: "M263.1,241.9c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1c7.7,0,14-6.2,14.1-14.1   C277.2,248.2,270.8,241.9,263.1,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "noun_chat_1133651_st2",
    d: "M175.5,241.9c-7.8,0-14.1,6.3-14.1,14.1s6.3,14.1,14.1,14.1c7.9,0,14.2-6.2,14.1-14.1   C189.6,248.2,183.2,241.9,175.5,241.9z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "noun_chat_1133651_st2",
    d: "M256,6C117.9,6,6,117.9,6,256s111.9,250,250,250s250-111.9,250-250S394.1,6,256,6z M219.8,341.5   c-14.9,0-29-2.1-42-6c-7,4.1-15.2,8.3-24.7,12c-18,7-34.5,9.8-46.8,10.9c6.8-3.7,20.9-12.5,31.3-29.6c2.1-3.4,3.8-6.8,5.2-10   c-7.6-5.3-14.4-11.5-19.9-18.2C112.2,287.4,106,272,106,255.4c0-47.6,50.9-86.1,113.8-86.1s113.9,38.5,113.8,86   C333.6,302.9,282.7,341.5,219.8,341.5z M373.1,319.7c10.9,17.9,25.5,27.1,32.5,30.9c-12.9-1.2-30-4.1-48.8-11.4   c-9.9-3.8-18.5-8.2-25.8-12.5c-13.5,4-28.2,6.3-43.7,6.3c-1.8,0-3.5,0-5.3-0.1c35.9-15.5,60-44.7,60-78.1   c0-48.1-49.7-87.3-112.5-89.8c17.1-7.3,36.9-11.4,57.9-11.4c65.5,0,118.6,40.2,118.6,89.7c0,17.2-6.4,33.3-17.6,47   c-5.7,7-12.7,13.5-20.7,19C369.2,312.7,370.9,316.2,373.1,319.7z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNounChat1133651);
export default __webpack_public_path__ + "static/media/noun_chat_1133651.3623cf48.svg";
export { ForwardRef as ReactComponent };